/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Styles */
import InsightSt from '@moms/styleData/InsightSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const SectionTitle = ({ region, lang, sectionContent }) => {
  return (
    <Box
      mt={{ base: '2rem', md: '8rem' }}
      maxW={{ base: '328px', md: '541px' }}
      mx={'auto'}
      {...InsightSt?.[lang]?.title}
    >
      <Text {...InsightSt?.[lang]?.titleSubtext} as="span">
        {sectionContent.titleText}
        <Text {...InsightSt?.[lang]?.text3} as="span">
          {' '}
          {sectionContent.titleSubtext}
        </Text>
      </Text>
    </Box>
  );
};

export default SectionTitle;
